import { render, staticRenderFns } from "./MdPainAssessmentNotesOutCome.vue?vue&type=template&id=6650a198&"
import script from "./MdPainAssessmentNotesOutCome.vue?vue&type=script&lang=js&"
export * from "./MdPainAssessmentNotesOutCome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports